import React, { useContext, useRef, useState } from 'react'
import { Col, Row, Card, Table, Form, Button } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Reward'
import RewardDetail from '../sub-screen/reward-detail/RewardDetail'
import PayReward from '../sub-screen/pay-reward/PayReward'
import BatchPayReward from '../sub-screen/batch-pay-reward/BatchPayReward'
import { deleteReward, recalculateReward } from '../../../../controller/api/__classic__/reward'
import { useCookies } from 'react-cookie'
import ImagePreview from "../../order/partials/image-preview/ImagePreview"

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [modalShow, setModalShow] = useState(false)

  const [payModalShow, setPayModalShow] = useState(false)

  const [batchPayModalShow, setBatchPayModalShow] = useState(false)

  const [selectedIds, setSelectedIds] = useState([])

  const [loading, setLoading] = useState(false)

  const rewardRef = useRef({})

  const transIdRef = useRef('')
  const ticketIdRef = useRef('')
  const phoneRef = useRef('')

  const [modalImageShow, setModalImageShow] = useState(false)
  const selectedImageRef = useRef("")
  const previewTitleRef = useRef("")

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title;
    selectedImageRef.current = image;
    setModalImageShow(true);
  }

  const onShowDetailPress = (reward) => {
    rewardRef.current = reward
    setModalShow(true)
  }

  const onPaidPress = (id, phone, ticket) => {
    ticketIdRef.current = ticket
    transIdRef.current = id
    phoneRef.current = phone
    setPayModalShow(true)
  }

  const onRecalculatePress = async (id) => {
    if (!window.confirm('Bạn có chắc muốn tính lại thưởng cho vé này?')) return

    setLoading(true)
    try {
      const response = await recalculateReward(cookies.lottmekong, id)
      if (response && response.status === 1) {
        alert(response.message || 'Tính lại thưởng thành công')
        // Refresh data
        dispatch({ type: 'SUBMIT_FILTER', payload: state.filter })
      } else {
        alert(response?.message || 'Lỗi tính lại thưởng')
      }
    } catch (err) {
      alert('Lỗi tính lại thưởng')
    }
    setLoading(false)
  }

  const onDeletePress = async (id) => {
    if (!window.confirm('Bạn có chắc muốn xóa record thưởng này?')) return

    setLoading(true)
    try {
      const response = await deleteReward(cookies.lottmekong, id)
      if (response && response.status === 1) {
        alert(response.message || 'Xóa thành công')
        // Remove from list
        const newData = {
          ...state.data,
          list: state.data.list.filter(item => item.id !== id),
          total: state.data.total - 1
        }
        dispatch({ type: 'UPDATE_DATA', payload: newData })
      } else {
        alert(response?.message || 'Lỗi xóa record')
      }
    } catch (err) {
      alert('Lỗi xóa record')
    }
    setLoading(false)
  }

  const handleSelectItem = (id, isChecked) => {
    if (isChecked) {
      setSelectedIds(prev => [...prev, id])
    } else {
      setSelectedIds(prev => prev.filter(item => item !== id))
    }
  }

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const unpaidIds = state.data.list
        .filter(item => !item.isPaid)
        .map(item => item.id)
      setSelectedIds(unpaidIds)
    } else {
      setSelectedIds([])
    }
  }

  const unpaidList = state.data.list ? state.data.list.filter(item => !item.isPaid) : []
  const isAllSelected = unpaidList.length > 0 && unpaidList.every(item => selectedIds.includes(item.id))

  return (
    <>
      {selectedIds.length > 0 && (
        <Card border="light" className="shadow-sm mb-3">
          <Card.Body className="d-flex align-items-center justify-content-between">
            <span>Đã chọn <strong>{selectedIds.length}</strong> mục chưa trả thưởng</span>
            <Button variant="danger" onClick={() => setBatchPayModalShow(true)}>
              Trả thưởng hàng loạt ({selectedIds.length})
            </Button>
          </Card.Body>
        </Card>
      )}
      <Card border="light" className="shadow-sm border-0">
        <Card.Body className="p-0">
            <Table responsive className="align-items-center table-flush table-hover">
              <thead className="thead-light">
                <tr>
                  <th className="border-bottom text-center" scope="col">
                    <Form.Check
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                      disabled={unpaidList.length === 0}
                    />
                  </th>
                  <th className="border-bottom text-center" scope="col">Ảnh</th>
                  <th className="border-bottom text-center" scope="col">Thao tác</th>
                  <th className="border-bottom text-center" scope="col">Người chơi</th>
                  <th className="border-bottom text-center" scope="col">Kỳ quay số</th>
                  <th className="border-bottom text-center" scope="col">Vé</th>
                  <th className="border-bottom text-center" scope="col">Giải thưởng</th>
                  <th className="border-bottom text-center" scope="col">Thuế</th>
                  <th className="border-bottom text-center" scope="col">Phí</th>
                  <th className="border-bottom text-center" scope="col">Thực nhận</th>
                </tr>
              </thead>
              <tbody>
                {state.data.list && state.data.list.map((pv, index) => (
                  <TableRow
                    onPaidPress={onPaidPress}
                    onShowDetailPress={onShowDetailPress}
                    onRecalculatePress={onRecalculatePress}
                    onDeletePress={onDeletePress}
                    rIndex={index}
                    key={`table-keys-lottmekong-${pv.id}`}
                    data={pv}
                    isSelected={selectedIds.includes(pv.id)}
                    onSelect={handleSelectItem}
                    onPreviewImage={showImagePreview}
                  />
                ))}
                {(!state.data.list || state.data.list.length === 0) && (
                  <tr>
                    <td colSpan={10} className="text-center py-4 text-muted">Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </Table>
        </Card.Body>
        <Card.Footer className="border-0 py-3 bg-light">
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <RewardDetail
        show={modalShow}
        reward={rewardRef.current}
        onHide={() => setModalShow(false)}
      />
      <PayReward
        show={payModalShow}
        transId={transIdRef.current}
        ticketId={ticketIdRef.current}
        phone={phoneRef.current}
        onHide={(status) => {
          setPayModalShow(false)

          if (status === 1) {
            // Reload data from server
            dispatch({ type: 'SUBMIT_FILTER', payload: state.filter })
          }
        }}
      />
      <BatchPayReward
        show={batchPayModalShow}
        selectedIds={selectedIds}
        onHide={(result) => {
          if (result && result.successCount > 0) {
            const newData = JSON.parse(JSON.stringify(state.data))

            for (let index = 0; index < newData.list.length; index++) {
              const element = newData.list[index];
              if (selectedIds.includes(element.id)) {
                element.isPaid = true
              }
            }

            dispatch({
              type: 'UPDATE_DATA',
              payload: newData
            })

            setSelectedIds([])
          }
          setBatchPayModalShow(false)
        }}
      />

      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
    </>
  );
};

export default React.memo(_Table)
